import { render, staticRenderFns } from "./Fifth.vue?vue&type=template&id=49e24573&"
import script from "./Fifth.vue?vue&type=script&lang=js&"
export * from "./Fifth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports